import React from 'react';
import './BookendSection.scss';
import Slider from "react-slick";
import { Button, Row, Col, Layout } from 'antd';
import { trackCta } from '../../../analytics';
import { buildRegisterUrl } from '../../../utils/registerRedirect';

const { Content } = Layout;
// ... (slider_images and slider_images_2 remain the same)
const slider_images = [
  '/smb/slider/slider (13).jpg',
  '/smb/slider/slider (1).jpeg',
  '/smb/slider/slider (16).png',
  '/smb/slider/slider (2).jpg',
  '/smb/slider/slider (6).jpg',
  '/smb/slider/slider (15).jpg',
  '/smb/slider/slider (5).jpg',
  '/smb/slider/slider (12).jpg',

]

const slider_images_2 = [
  '/smb/slider/slider (3).jpg',
  '/smb/slider/slider (10).jpg',
  '/smb/slider/slider (4).jpg',
  '/smb/slider/slider (11).jpg',
  '/smb/slider/slider (14).jpg',
  '/smb/slider/slider (7).jpg',
  '/smb/slider/slider (8).jpg',
  '/smb/slider/slider (9).jpg'
]


const BookendSection = () => {
  return (
    <>
      <WebVersion />
      <MobileVersion />
    </>
  );
};

const WebVersion = () => {
  const settings = {
    autoplay: true,
    dots: false,
    infinite: true,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    vertical: true,
    speed: 6000,
    autoplaySpeed: 6000,
    cssEase: "linear",
    pauseOnHover: false,
  };

  const settings_2 = {
    autoplay: true,
    dots: false,
    infinite: true,
    slidesToShow: 1.5,
    slidesToScroll: -1,
    vertical: true,
    speed: 6000,
    autoplaySpeed: 6000,
    cssEase: "linear",
    pauseOnHover: false,
  };
  const redirectPath = `/select-subscription?plan=free_trial_ai&plan_type=smb_3d_services`;


  return (<Content className="d-none d-lg-block">
    <Row className="container-fluid justify-space-between bookend-section" style={{ minHeight: '600px' }}>
      <Col span={11} className='justify-in-start direction-flex' style={{ padding: 0, display: 'flex' }}>
        <img className='img-styles' src='/smb/Slider.png' alt='Examples of AI-generated ecommerce product imagery' />
      </Col>
      <Col span={13} className="section-text">
        <h3 className='manrope f-50 w-600 black-085 lh-58 mb-16'>Join the future of ecommerce</h3>

        <p className='manrope f-16 w-500 black-085 lh-24 mb-32'>Try the ALL3D platform for free to start your switch to 3D.</p>

        <div className="justify-in-start">
          <Button onClick={() => {
            trackCta('free_trial_click', {
              section: 'bookend',
              placement: 'desktop',
              button: 'get_started_for_free',
            });
            window.open(buildRegisterUrl(redirectPath), "_blank")
          }}
            className={`manrope f-16 w-700 lh-24 blue-button`}>
            Get started for free
          </Button>
          <Button onClick={() => {
            window.location.href = '/pricing'
          }}
            className={`manrope f-16 w-700 lh-24 white-button-black-border ml-16`}
          >
            View pricing & plans
          </Button>
        </div>
      </Col>
    </Row>
  </Content>
  );
};


const MobileVersion = () => {
  const settings = {
    autoplay: true,
    dots: false,
    infinite: true,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    vertical: true,
    speed: 6000,
    autoplaySpeed: 6000,
    cssEase: "linear",
    pauseOnHover: false
  };


  const settings_2 = {
    autoplay: true,
    dots: false,
    infinite: true,
    slidesToShow: 1.5,
    slidesToScroll: -1,
    vertical: true,
    speed: 6000,
    autoplaySpeed: 6000,
    cssEase: "linear",
    pauseOnHover: false
  };
  const redirectPath = `/select-subscription?plan=free_trial_ai&plan_type=smb_3d_services`;


  return (<Content className="d-lg-none">
    <Row className="container-fluid bookend-section-mobile">
      <Col span={24}>
        <h1 className="manrope f-38 w-600 black-085 lh-46 mb-16 text-left">
          Join the future of ecommerce
        </h1>
        <h5 className="manrope f-16 w-500 black-085 lh-24 mb-24 text-left">
          Try the ALL3D platform for free to start your switch to 3D.
        </h5>

      </Col>
      <Col span={24} className="justify-in-center direction-flex height-max-c mb-24" style={{ padding: 0 }}>
        <img className='img-styles' src='/smb/Slider.png' alt='Examples of AI-generated ecommerce product imagery' />
      </Col>
      <Col span={24}>
        <Button onClick={() => {
          trackCta('free_trial_click', {
            section: 'bookend',
            placement: 'mobile',
            button: 'get_started_for_free',
          });
          window.open(buildRegisterUrl(redirectPath), "_blank")
        }}
          className={`manrope f-16 w-700 lh-24 blue-button w-100 centerCarousel mb-16`}
          block>
          Get started for free
        </Button>
        <Button onClick={() => {
          window.location.href = '/pricing'
        }}
          className={`manrope f-16 w-700 lh-24 w-100 white-button-black-border centerCarousel`}
          block>
          View pricing & plans
        </Button>
      </Col>
    </Row>
  </Content>)
}
export default BookendSection;
